import React from 'react'
import LoginForm from '../Components/Forms/LoginForm'

const Login = () => {
  return (
    <div className="login">
      <LoginForm />
    </div>
  )
}

export default Login
